module.exports = __webpack_public_path__ + "img/map-tanzania.a713c4f6.png";